import "./datatable.scss";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  feesformColumns,
  feesformRows,
  fetchFeesformRows,
} from "../../datatablesource";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSlug } from "../../SlugContext";
import { serverUrl } from "../../temp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../loader/Loader";
const FeesFormDataTable = () => {
  const [data, setData] = useState(feesformRows);
  const [loading, setLoading] = useState(false);
  const { slugs } = useSlug();
  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const rows = await fetchFeesformRows();
      console.log("jawad", rows);
      setLoading(false);
      setData(Array.from(rows.data));
    };
    getData();
  }, []);

  const handleDelete = (id) => {
    // Make a DELETE request to the Flask API endpoint
    fetch(`${serverUrl}/del_examination/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to delete teacher");
        }
        setData(data.filter((item) => item.id !== id));
        toast.success("Teacher deleted successfully!");
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };
  const listingLinkString = "Awardlist-Listing";
  const viewLinkString = "Feesform-Single";
  const editLinkString = "Feesform-Edit";
  const newLinkString = "Feesform-New";

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 300,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {slugs && slugs.includes(viewLinkString) && (
              <Link
                to={`/fees-form/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="viewButton">View</div>
              </Link>
            )}
            {slugs && slugs.includes(editLinkString) && (
              <Link
                to={`/fees-form/update-feesform/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="editButton">Edit</div>
              </Link>
            )}
            <div
              className="deleteButton disabled"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="datatable">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between w-full gap-3 pb-2 lg:pb-2">
        <div className="text-gray-700 text-2xl">Receipt Book Details</div>
        <div className="flex flex-col sm:flex-row gap-2 w-full lg:w-auto">
          {slugs && slugs.includes(newLinkString) && (
            <Link to="/fees-form/new" className="commonButton w-full sm:w-auto">
              Add New
            </Link>
          )}
        </div>
      </div>
      {loading ? (
        // <h1 style={{ textAlign: "center", paddingTop: "20%" }}>loading...</h1>
        <Loader fullScreen={false} />
      ) : (
        <DataGrid
          className="datagrid"
          rows={data}
          columns={feesformColumns.concat(actionColumn)}
          pageSize={9}
          rowsPerPageOptions={[9]}
          components={{
            Toolbar: GridToolbar, // Include the GridToolbar in the Toolbar slot
          }}
        />
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default FeesFormDataTable;
